// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AffiliateProgramTermsRouteImport } from './routes/affiliate-program-terms'
import { Route as AffiliatesRouteImport } from './routes/affiliates'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as TermsOfUseRouteImport } from './routes/terms-of-use'
import { Route as CopilotSplatRouteImport } from './routes/copilot.$'
import { Route as McpIndexRouteImport } from './routes/mcp.index'
import { Route as McpBestMcpServersForDesignersRouteImport } from './routes/mcp.best-mcp-servers-for-designers'
import { Route as McpClaudeRouteImport } from './routes/mcp.claude'
import { Route as McpClaudeCodeRouteImport } from './routes/mcp.claude-code'
import { Route as McpCodexRouteImport } from './routes/mcp.codex'
import { Route as McpCursorRouteImport } from './routes/mcp.cursor'
import { Route as McpFlowstepVsFigmaMcpRouteImport } from './routes/mcp.flowstep-vs-figma-mcp'
import { Route as McpWhatIsMcpForDesignersRouteImport } from './routes/mcp.what-is-mcp-for-designers'
import { Route as McpWindsurfRouteImport } from './routes/mcp.windsurf'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AffiliateProgramTermsRoute = AffiliateProgramTermsRouteImport.update({
            id: '/affiliate-program-terms',path: '/affiliate-program-terms',getParentRoute: () => rootRouteImport
          })
const AffiliatesRoute = AffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => rootRouteImport
          })
const CookiePolicyRoute = CookiePolicyRouteImport.update({
            id: '/cookie-policy',path: '/cookie-policy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const TermsOfUseRoute = TermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => rootRouteImport
          })
const CopilotSplatRoute = CopilotSplatRouteImport.update({
            id: '/copilot/$',path: '/copilot/$',getParentRoute: () => rootRouteImport
          })
const McpIndexRoute = McpIndexRouteImport.update({
            id: '/mcp/',path: '/mcp/',getParentRoute: () => rootRouteImport
          })
const McpBestMcpServersForDesignersRoute = McpBestMcpServersForDesignersRouteImport.update({
            id: '/mcp/best-mcp-servers-for-designers',path: '/mcp/best-mcp-servers-for-designers',getParentRoute: () => rootRouteImport
          })
const McpClaudeRoute = McpClaudeRouteImport.update({
            id: '/mcp/claude',path: '/mcp/claude',getParentRoute: () => rootRouteImport
          })
const McpClaudeCodeRoute = McpClaudeCodeRouteImport.update({
            id: '/mcp/claude-code',path: '/mcp/claude-code',getParentRoute: () => rootRouteImport
          })
const McpCodexRoute = McpCodexRouteImport.update({
            id: '/mcp/codex',path: '/mcp/codex',getParentRoute: () => rootRouteImport
          })
const McpCursorRoute = McpCursorRouteImport.update({
            id: '/mcp/cursor',path: '/mcp/cursor',getParentRoute: () => rootRouteImport
          })
const McpFlowstepVsFigmaMcpRoute = McpFlowstepVsFigmaMcpRouteImport.update({
            id: '/mcp/flowstep-vs-figma-mcp',path: '/mcp/flowstep-vs-figma-mcp',getParentRoute: () => rootRouteImport
          })
const McpWhatIsMcpForDesignersRoute = McpWhatIsMcpForDesignersRouteImport.update({
            id: '/mcp/what-is-mcp-for-designers',path: '/mcp/what-is-mcp-for-designers',getParentRoute: () => rootRouteImport
          })
const McpWindsurfRoute = McpWindsurfRouteImport.update({
            id: '/mcp/windsurf',path: '/mcp/windsurf',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AffiliateProgramTermsRoute: AffiliateProgramTermsRoute,AffiliatesRoute: AffiliatesRoute,CookiePolicyRoute: CookiePolicyRoute,PricingRoute: PricingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,TermsOfUseRoute: TermsOfUseRoute,CopilotSplatRoute: CopilotSplatRoute,McpBestMcpServersForDesignersRoute: McpBestMcpServersForDesignersRoute,McpClaudeRoute: McpClaudeRoute,McpClaudeCodeRoute: McpClaudeCodeRoute,McpCodexRoute: McpCodexRoute,McpCursorRoute: McpCursorRoute,McpFlowstepVsFigmaMcpRoute: McpFlowstepVsFigmaMcpRoute,McpWhatIsMcpForDesignersRoute: McpWhatIsMcpForDesignersRoute,McpWindsurfRoute: McpWindsurfRoute,McpIndexRoute: McpIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)